import { safeCombineEpics } from '@cbridge-utils/redux-observable';
import { loadSymbolEpic } from './_epics/loadSymbol.epic';
import { loadSymbolListEpic } from './_epics/loadSymbolList.epic';
import { loadBaseSymbolsEpic } from './_epics/loadBaseSymbols.epic';
import { createSymbolEpic } from './_epics/createSymbol.epic';
import { updateSymbolEpic } from './_epics/updateSymbol.epic';
import { removeSymbolEpic } from './_epics/removeSymbol.epic';
import { startSymbolProcessingEpic } from './_epics/startSymbolProcessing.epic';
import { endSymbolProcessingEpic } from './_epics/endSymbolProcessing.epic';
import { exportSymbolsEpic } from './_epics/exportSymbols.epic';
import { bulkUpdateSymbolsEpic } from './_epics/bulkUpdateSymbols.epic';
import { bulkRemoveSymbolsEpic } from './_epics/bulkRemoveSymbols.epic';

export const symbolEpic = safeCombineEpics(
  loadSymbolEpic,
  loadSymbolListEpic,
  loadBaseSymbolsEpic,
  createSymbolEpic,
  updateSymbolEpic,
  removeSymbolEpic,
  startSymbolProcessingEpic,
  endSymbolProcessingEpic,
  exportSymbolsEpic,
  bulkUpdateSymbolsEpic,
  bulkRemoveSymbolsEpic,
);
